import { useEffect } from "react";
import { logError } from "repoV2/utils/common/error/error";
import { ISalePageContextValue } from "../SalePageContext";
import { IRecordedContentCatalogueDataFromApi } from "./apis/getRecordedContentCatalogueDataApi/getRecordedContentCatalogueDataApi.interfaces";
import { callGetSalePageTemplateDataApi } from "./apis/getSalePageTemplateDataApi/getSalePageTemplateDataApi.api";
import { ISalePageSectionsDataFromApi } from "./apis/getSalePageTemplateDataApi/getSalePageTemplateDataApi.interfaces";
import { SECTIONS_TO_LOAD_ON_USER_INTERACTION } from "./sale.constants";

export const useLoadAllSectionsOnInteraction = ({
    salePageUuid,
    contextValue,
    setContextValue,
    recordedContentCatalogueItemsList,
}: {
    salePageUuid: string;
    contextValue: ISalePageContextValue;
    setContextValue: React.Dispatch<
        React.SetStateAction<ISalePageContextValue>
    >;
    recordedContentCatalogueItemsList?: IRecordedContentCatalogueDataFromApi;
}) => {
    useEffect(() => {
        async function handleInteraction() {
            removeEventListeners();

            let sectionsData: ISalePageSectionsDataFromApi | undefined;
            try {
                const salePageTemplateData =
                    await callGetSalePageTemplateDataApi({
                        salePageUuid,
                        startRange:
                            SECTIONS_TO_LOAD_ON_USER_INTERACTION.START_RANGE,
                        defaultSectionsData: contextValue.sectionsData,
                        recordedContentCatalogueItemsList,
                    });
                sectionsData = salePageTemplateData.sectionsData;
            } catch (error) {
                logError({
                    error,
                    occuredAt: "useLoadAllSectionsOnInteraction",
                    when: "callGetSalePageSectionsDataApi",
                });
            }
            if (sectionsData) {
                setContextValue({
                    ...contextValue,
                    sectionsData: { ...sectionsData },
                });
            }
        }

        function addEventListeners() {
            document.addEventListener("scroll", handleInteraction);
            document.addEventListener("keydown", handleInteraction);
            document.addEventListener("click", handleInteraction);
            document.addEventListener("touchstart", handleInteraction);
        }

        function removeEventListeners() {
            document.removeEventListener("scroll", handleInteraction);
            document.removeEventListener("keydown", handleInteraction);
            document.removeEventListener("click", handleInteraction);
            document.removeEventListener("touchstart", handleInteraction);
        }

        addEventListeners();

        return () => {
            removeEventListeners();
        };
    }, []);
};
